// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__8h-j3","header":"PatientBlock_header__7pt9a","label":"PatientBlock_label__2bBCp","option":"PatientBlock_option__3OiWW"};